<div class="block-list row">
  @for (item of items; track item; let i = $index) {
    <div
      class="block-item"
      draggable="true"
      (dragstart)="onDragStart($event)"
      (drop)="dropBlock($event)"
      (dragend)="dropBlock($event)"
      (drag)="dragBlock($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragOut($event)"
      (click)="selectItem(getItemIdentifierFromItem(item))"
      [attr.itemIdentifier]="getItemIdentifierFromItem(item)"
      [ngClass]="{ 'drop-zone': dragging && dropEnabled, 'draggable': dragEnabled, 'selectable': selectable, 'selected': selectable && selectedItemIdentifier == getItemIdentifierFromItem(item) }">
      @if (blockListType == 'user') {
        <blocklist-user [user]="item" />
      }
      @if (blockListType == 'qualificationCall') {
        <blocklist-qualification-call [qualificationCall]="item" />
      }
      @if (blockListType == 'questionnaire') {
        <blocklist-questionnaire [questionnaire]="item" />
      }
      @if (blockListType == 'orderOnboarding') {
        <blocklist-order-onboarding [orderOnboardingView]="item" />
      }
    </div>
  }
  <div class="ghost-block" #ghostBlock>
    <img src="/assets/images/blockghost.svg" />
  </div>
</div>